import { core, dateUtil } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    table(opt, tar) {
      const th = '<th></th>'
      const td = '<td><div><span></span></div></td>'
      const tr = `<tr class="date-table__row">${Array(7).fill(td).join('')}</tr>`
      const table = $(`
      <table cellspacing="0" cellpadding="0" class="date-table">
        <tbody>
          <tr>${Array(7).fill(th).join('')}</tr>${Array(6).fill(tr).join('')}
        </tbody>
      </table>`)
      const weeks = opt.weeks
      Array.from(table.find('th')).map((node, i) => {
        $(node).text(weeks[i])
      })
      return table
    }
  },
  updater: {
    // 基本属性: date
    date(value, opt, tar, node) {
      const cells = tar.unit.find('span')
      const start = tar.startDate()
      Array.from(cells).map((item, i) => {
        const next = dateUtil.nextDate(start, i)
        const [year, month, date] = dateUtil.getDateArr(next)
        $(item).text(date)
        const td = $(item).closest('td')
        td.attr('month', month)
        // 增加前/后月的标识
        const [y, m, d] = dateUtil.getDateArr(value)
        if (month === m + 1) td.addClass('next-month').removeClass('available')
        else if (month === m - 1) td.addClass('prev-month').removeClass('available')
        else td.addClass('available').removeClass('next-month').removeClass('prev-month')
        // 增加已选中的标识
        if (year === y && month === m && date === d) td.addClass('current')
        else td.removeClass('current')
        // 增加今日标识
        const [yy, mm, dd] = dateUtil.getDateArr(new Date())
        if (year === yy && month === mm && date === dd) td.addClass('today')
        else td.removeClass('today')
      })
    },
    // 基本功能: 是否显示
    show(value, opt, tar, node) {
      if (value) {
        tar.unit.show()
      } else {
        tar.unit.hide()
      }
      tar.shown()
    }
  }
}

export default class DateTable extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      show: false, // 基本功能: 显示/隐藏
      weeks: ['日', '一', '二', '三', '四', '五', '六'], // 基本属性: 周表
      date: new Date(), // 基本属性: 设置时间
      max: null, // 基本属性: 最大时间
      min: null // 基本属性: 最小时间
    }
    this.events = {
      click: 'onClick',
      shown: null
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.table(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    this.unit.click($.proxy(this.click, this))
  }

  startDate() {
    return dateUtil.getStartDateOfMonth(this.year, this.month)
  }

  getDateOfCell(year, month, date) {
    return new Date(year, month, date)
  }

  onClick(event) {
    let target = event.target
    if (target.tagName === 'SPAN') {
      target = target.parentNode.parentNode
    }
    if (target.tagName === 'DIV') {
      target = target.parentNode
    }
    if (target.tagName !== 'TD') return false
    if ($(target).hasClass('disabled')) return false
    if ($(target).parent().hasClass('disabled')) {
      return false
    }
    const month = $(target).attr('month')
    const date = target.textContent || target.innerText
    return this.getDateOfCell(this.year, month * 1, date * 1)
  }

  get year() {
    return this.date.getFullYear()
  }

  get month() {
    return this.date.getMonth()
  }
}
